import { siteUrl, siteName } from "@/mocks/site";
import type { Article } from "@/mocks/articles";

const LOGO_URL =
  "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/0dc5bc4081b05862da3d01553c9c9d93.png";

function JsonLd({ data }: { data: Record<string, unknown> }) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

export function WebsiteJsonLd() {
  const data = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: siteName,
    url: `${siteUrl}/`,
    description:
      "Basetao Spreadsheet is your independent hub for Basetao product research, finds, QC photos, shipping costs, and buyer guides.",
    inLanguage: "en",
  };
  return <JsonLd data={data} />;
}

export function OrganizationJsonLd() {
  const data = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: siteName,
    url: `${siteUrl}/`,
    logo: LOGO_URL,
  };
  return <JsonLd data={data} />;
}

export function ArticleJsonLd({ article }: { article: Article }) {
  const data = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: article.title,
    description: article.metaDescription,
    image: article.image,
    datePublished: "2026-08-19",
    dateModified: "2026-08-19",
    author: {
      "@type": "Organization",
      name: siteName,
    },
    publisher: {
      "@type": "Organization",
      name: siteName,
      logo: {
        "@type": "ImageObject",
        url: LOGO_URL,
      },
    },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": `${siteUrl}/${article.slug}`,
    },
  };
  return <JsonLd data={data} />;
}

export function FaqJsonLd({ faqs }: { faqs: { q: string; a: string }[] }) {
  const data = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.a,
      },
    })),
  };
  return <JsonLd data={data} />;
}